import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import { toggleBar } from '../../redux/reducers/optionsReducers'
import authQueries from '../../queries/authQueries'
import { updateSubscription } from '../../redux/reducers/authReducers'

const PageLayout = () => {

  const toggle = useSelector((state) => state.options.toggleBar)
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user);

  const handleToggle = () => {
    dispatch(toggleBar())
  }

  const getSubscriptionStatus = authQueries.useGetSubscriptionStatus(
    (res)=>{
      dispatch(updateSubscription(res?.subscription))
    }
  )

  useEffect(() => {
    getSubscriptionStatus.mutateAsync()
  }, []);

  return (
    <Fragment>



      <Sidebar handleToggle={handleToggle} />

      <div className="flex flex-col h-screen overflow-y-auto overflow-x-hidden">
        <div className={`fixed top-0 right-0 left-0 z-40 ${toggle?"ml-[280px]":"ml-[70px]"} transition-all duration-300 max-[1024px]:ml-0`}>
          <Header handleToggle={handleToggle} />
        </div>
        <div className={`${toggle?"ml-[280px]":"ml-[70px]"} p-7 mt-[70px] transition-all duration-300 max-[1024px]:ml-0 max-[410px]:p-0`}>
          <div className='w-full max-[410px]:p-3 text-[14px]'>
            <Outlet />
          </div>
        </div>
      </div>

    </Fragment>
  )
}

export default PageLayout

